// Some browsers still report retired zone names; store and show the current ones.
const CANONICAL_ZONES = {
  "Asia/Calcutta": "Asia/Kolkata", "Europe/Kiev": "Europe/Kyiv", "Asia/Saigon": "Asia/Ho_Chi_Minh", "Asia/Katmandu": "Asia/Kathmandu",
  "Asia/Rangoon": "Asia/Yangon", "America/Buenos_Aires": "America/Argentina/Buenos_Aires", "America/Godthab": "America/Nuuk",
  "Atlantic/Faeroe": "Atlantic/Faroe", "Pacific/Ponape": "Pacific/Pohnpei", "Pacific/Truk": "Pacific/Chuuk",
  "America/Indianapolis": "America/Indiana/Indianapolis", "America/Louisville": "America/Kentucky/Louisville",
};
export const canonicalZone = (z) => CANONICAL_ZONES[z] || z;

export const TIME_ZONES = typeof Intl.supportedValuesOf === "function"
  ? [...new Set(Intl.supportedValuesOf("timeZone").map(canonicalZone))].sort()
  : [];

export const browserTimeZone = () => {
  try {
    return canonicalZone(Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC");
  } catch {
    return "UTC";
  }
};

export const userTimeZone = (me) => me?.settings?.timezone || browserTimeZone();

export const RECURRENCE = [
  { value: "none", label: "Doesn't repeat", short: "" },
  { value: "daily", label: "Every day", short: "Daily" },
  { value: "weekdays", label: "Every weekday (Mon–Fri)", short: "Weekdays" },
  { value: "weekly", label: "Every week", short: "Weekly" },
  { value: "monthly", label: "Every month", short: "Monthly" },
];

export const PRIORITY = [
  { value: "none", label: "None" },
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
];

export const PRIORITY_COLOR = { high: "text-rose-300", medium: "text-amber-200", low: "text-sky-300" };

export const STATE_COLOR = { overdue: "text-rose-300", today: "text-amber-200", upcoming: "text-zinc-400", no_date: "text-zinc-500" };

export const GROUPS = [
  { key: "overdue", label: "Overdue" },
  { key: "today", label: "Today" },
  { key: "upcoming", label: "Upcoming" },
  { key: "no_date", label: "No date" },
];

const TIMED_REMINDERS = [["0", "At the time of the task"], ["5", "5 minutes before"], ["15", "15 minutes before"], ["30", "30 minutes before"], ["60", "1 hour before"], ["120", "2 hours before"], ["1440", "1 day before"]];
const ALL_DAY_REMINDERS = [["0", "On the day at 9:00 AM"], ["1440", "The day before at 9:00 AM"], ["10080", "A week before at 9:00 AM"]];

export function reminderOptions(allDay, current) {
  const list = allDay ? ALL_DAY_REMINDERS : TIMED_REMINDERS;
  const extra = current !== "" && !list.some(([v]) => v === String(current)) ? [[String(current), `${current} minutes before`]] : [];
  return [["", "No reminder"], ...list, ...extra];
}

const ymdFormat = (tz) => new Intl.DateTimeFormat("en-CA", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit" });

export const ymdInTz = (date, tz) => ymdFormat(tz).format(date);

export function addDays(ymd, n) {
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
}

export function dayLabel(ymd, tz) {
  const today = ymdInTz(new Date(), tz);
  if (ymd === today) return "Today";
  if (ymd === addDays(today, 1)) return "Tomorrow";
  if (ymd === addDays(today, -1)) return "Yesterday";
  const [y, m, d] = ymd.split("-").map(Number);
  const sameYear = y === Number(today.slice(0, 4));
  return new Intl.DateTimeFormat(undefined, { timeZone: "UTC", weekday: "short", day: "numeric", month: "short", ...(sameYear ? {} : { year: "numeric" }) }).format(new Date(Date.UTC(y, m - 1, d)));
}

export function timeLabel(hhmm) {
  const [h, m] = hhmm.split(":").map(Number);
  return new Intl.DateTimeFormat(undefined, { timeZone: "UTC", hour: "numeric", minute: "2-digit" }).format(new Date(Date.UTC(2000, 0, 1, h, m)));
}

export function dueLabel(task, tz) {
  if (!task?.due_date) return null;
  return task.due_time ? `${dayLabel(task.due_date, tz)} · ${timeLabel(task.due_time)}` : dayLabel(task.due_date, tz);
}

export function instantLabel(iso, tz) {
  const date = new Date(iso);
  const time = new Intl.DateTimeFormat(undefined, { timeZone: tz, hour: "numeric", minute: "2-digit" }).format(date);
  return `${dayLabel(ymdInTz(date, tz), tz)} · ${time}`;
}

export const newRequestId = () => crypto.randomUUID();
